import { useLocale } from '@/shared/lib/i18n/locale-context';
import { useBrokerStatus } from '@/shared/lib/mqtt/use-broker-status';

/**
 * The card at the foot of the rail.
 *
 * ⚠️ **What was here was an advertisement for TailAdmin Pro** — "#1 Tailwind CSS Dashboard",
 * "Purchase Plan", linking to their pricing page. Left in place it would sit at the bottom of the
 * navigation on every screen of a search-and-rescue charity's operations panel, offering the
 * association a $49 upgrade to a product it has never heard of. Keeping the template whole does not
 * extend to keeping somebody else's sales copy in front of the client.
 *
 * ⚠️ **What replaces it earns the space: whether live updates are arriving.** A control room cannot
 * tell a quiet night from a dead connection, and that is the one fact that belongs permanently on
 * screen. Every figure in the panel still comes from the API, so a broker that is down costs
 * freshness rather than function — but an operator who does not know they have stopped receiving
 * events will keep reading a screen that no longer changes.
 *
 * ⚠️ Hidden when the rail is collapsed, which the template already handles: `AppSidebar` renders
 * this only while labels are showing, and a status told in words is nothing at 90px.
 */
export default function SidebarWidget() {
  const { t } = useLocale();
  const status = useBrokerStatus();

  const tone =
    status === 'live'
      ? 'bg-success-500'
      : status === 'connecting'
        ? 'bg-warning-500'
        : 'bg-gray-400';

  const label =
    status === 'live'
      ? t.app.liveOn
      : status === 'connecting'
        ? t.app.liveConnecting
        : t.app.liveOff;

  return (
    <div className="mx-auto mb-10 w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-4 dark:bg-white/[0.03]">
      <p className="flex items-start gap-2 text-theme-xs text-gray-500 dark:text-gray-400">
        <span className={`mt-1 size-2 shrink-0 rounded-full ${tone}`} aria-hidden="true" />
        <span>{label}</span>
      </p>
    </div>
  );
}
